import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    const urlParams = new URLSearchParams(window.location.search)
    const query = urlParams.get("q")
    if (query) this.submit()
  }

  submit(event) {
    if (this.inputTarget.value.length < 3) return

    const url = new URL(window.location)
    url.searchParams.set("q", this.inputTarget.value)
    window.history.pushState({}, "", url)

    clearTimeout(this.timeout)
    if (event) {
      clearTimeout(this.analyticsTimeout)
      this.analyticsTimeout = setTimeout(() => {
        this.element.dispatchEvent(new CustomEvent("analytics:search", { bubbles: true }))
      }, 1000)
    }
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, 300) // debounce for 300ms
  }

  disconnect() {
    clearTimeout(this.timeout)
    clearTimeout(this.analyticsTimeout)
  }
}
